<template>
	<div class="app-why-box">
		<div class="app-why-box-icon" v-html="obj.svg"></div>
		<h4>{{ obj.title }}</h4>
		<p class="mb-0" style="font-weight: bold">{{ obj.text }}</p>
	</div>
</template>

<script>
export default {
	props: {
		obj: {
			required: true,
			type: Object,
			default: () => {}
		}
	}
};
</script>

<style>
.app-why-box {
	width: 100%;
	background: #fff;
	border: 1px solid #ecedee;
	border-radius: 10px;
	text-align: center;
	padding: 20px 13px;
	transition: all 0.3s ease;
	margin-bottom: 30px;
	min-height: 320px;
}
.app-why-box:hover {
	box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}
.app-why-box-icon {
	margin: 0 auto;
	width: 70px;
	height: 70px;
	background: #fff;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
	border-radius: 7px;
	padding: 10px;
	transition: all 0.3s ease;
}
.app-why-box h4 {
	font-size: 18px;
	margin: 15px 0 10px;
	transition: all 0.3s ease;
	min-height: 50px;
	display: flex;
	align-items: center;
	line-height: 1.3;
	justify-content: center;
	width: 100%;
}
.app-why-box-icon svg circle,
.app-why-box-icon svg ellipse,
.app-why-box-icon svg path,
.app-why-box-icon svg polygon,
.app-why-box-icon svg rect {
	transition: all 0.3s ease;
	fill: #6a6d6f;
}
.app-why-box:hover .app-why-box-icon {
	background: #1977cc;
}
.app-why-box:hover .app-why-box-icon svg circle,
.app-why-box:hover .app-why-box-icon svg ellipse,
.app-why-box:hover .app-why-box-icon svg path,
.app-why-box:hover .app-why-box-icon svg polygon,
.app-why-box:hover .app-why-box-icon svg rect {
	fill: #fff;
}
</style>
